
export default function SolutionSection() {
  return (
    <section id="features" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* 左側ビジュアルエリア */}
          <div className="order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <div className="w-full h-[520px] flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/6d55260ef143ff58f309b374bc1c9f03/b4cc1134352cb07b03e1515b4916766c.jpeg"
                  alt="Atelier Folio 25度の角度"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* 角度バッジ */}
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm rounded-xl px-5 py-3 shadow-lg">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#8B6BAE]/10 rounded-full">
                    <i className="ri-ruler-line text-lg text-[#8B6BAE]"></i>
                  </div>
                  <div>
                    <p className="text-sm font-bold text-gray-900">25°</p>
                    <p className="text-xs text-gray-500">推奨角度</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 右側テキストエリア */}
          <div className="order-1 lg:order-2">
            <div className="inline-block px-4 py-1.5 bg-[#8B6BAE]/10 rounded-full mb-6">
              <span className="text-xs font-semibold tracking-wider text-[#8B6BAE]">SOLUTION</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-10 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Atelier Folio for iPadは、<br />
              <span className="text-[#8B6BAE]">イラストレーターの手首</span>から<br />設計しました。
            </h2>

            <div className="bg-gradient-to-br from-[#8B6BAE]/5 to-[#8B6BAE]/10 border border-[#8B6BAE]/20 rounded-2xl p-8 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl shadow-sm flex-shrink-0">
                  <i className="ri-heart-pulse-line text-2xl text-[#8B6BAE]"></i>
                </div>
                <div>
                  <p className="text-xl font-bold text-gray-900 mb-2">
                    医学的に推奨される<br />
                    25°以下の描画角度
                  </p>
                  <p className="text-sm text-gray-600">
                    用途別に最適化された複数角度を搭載
                  </p>
                </div>
              </div>
            </div>

            {/* 医学的裏付け情報 */}
            <div className="space-y-5 mb-10">
              {/* 問題提起 */}
              <div className="flex gap-4 p-5 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-[#E57373]/10 rounded-xl">
                  <i className="ri-alert-line text-xl text-[#E57373]"></i>
                </div>
                <div>
                  <h4 className="text-base font-bold text-gray-900 mb-1">長時間作業による手首の負担</h4>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    フラットな画面での作業は手首を過度に反らせ、手根管内圧が平常時の10倍近くに達することも。
                  </p>
                </div>
              </div>

              {/* 医学的根拠 */}
              <div className="flex gap-4 p-5 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-[#8B6BAE]/10 rounded-xl">
                  <i className="ri-heart-pulse-line text-xl text-[#8B6BAE]"></i>
                </div>
                <div>
                  <h4 className="text-base font-bold text-gray-900 mb-1">人間工学に基づく角度設計</h4>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    英国の作業姿勢ガイドでは10°〜25°の傾斜を推奨。手首を自然な角度に保ち、負荷を軽減。
                  </p>
                </div>
              </div>

              {/* 解決策 */}
              <div className="flex gap-4 p-5 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-[#6B9B8A]/10 rounded-xl">
                  <i className="ri-check-double-line text-xl text-[#6B9B8A]"></i>
                </div>
                <div>
                  <h4 className="text-base font-bold text-gray-900 mb-1">10°・20°・25°の3段階</h4>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    医学的エビデンスとプロの声から生まれた「手首にやさしい角度」を実現。
                  </p>
                </div>
              </div>
            </div>

            <p className="text-lg text-gray-500 italic leading-relaxed border-l-4 border-[#8B6BAE]/30 pl-5">
              角度を探す時間を、<br />
              描く時間に変えます。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
